import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAF1GDjn5yirzanDxtbpIXu-AhNaf-OLpE",
  authDomain: "viriyaeducation.firebaseapp.com",
  projectId: "viriyaeducation",
  storageBucket: "viriyaeducation.firebasestorage.app",
  messagingSenderId: "183852236750",
  appId: "1:183852236750:web:9cf19d3dcff119431e359f",
};

// 2. Initialize Firebase
const app = initializeApp(firebaseConfig);

// 3. Get the Firestore service - 🟢 ADD 'export' HERE
export const db = getFirestore(app);

/**
 * Function to handle saving form data
 */
export const saveApplication = async (data) => {
  try {
    const docRef = await addDoc(collection(db, "applications"), {
      ...data,
      submittedAt: serverTimestamp(), // Better for global time zones
    });
    console.log("Application submitted with ID: ", docRef.id);
    return { success: true, docId: docRef.id };
  } catch (e) {
    console.error("Error adding document: ", e);
    return { success: false, error: e.message };
  }
};
